export enum PreferenceName {
  LAST_ACCESSED_WORKSPACE_ID = "LastAccessedCompanyId",
  LIST_SIZES = "ListSizes"
}
